import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {AreaIcon, CalendarCheckIcon, FloorIcon, RoomsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IPersonalizedPropertyCard} from "../../types/IPersonalizedHomepage";

interface IProps {
    property: IPersonalizedPropertyCard;
    index: number;
    onPropertyClick?: (property: IPersonalizedPropertyCard, index: number) => void;
}

export const PersonalizedHomepageRecentlyViewedTile = (props: IProps) => {
    const {property, index, onPropertyClick} = props;

    return (
        <a className={tileStyle} href={property.href} title={property.offerName} onClick={() => onPropertyClick?.(property, index)}>
            <span className={photoStyle}>
                <img className={photoImageStyle} src={property.imageUrl} alt={property.imageAlt} loading="lazy" />
            </span>

            <span className={detailsStyle}>
                <span className={descriptionStyle}>
                    <Text as="span" variant="headline_6" className={titleStyle}>
                        {property.offerName}
                    </Text>
                    <Text as="span" variant="info_txt_1" className={addressStyle}>
                        {property.addressLine}
                    </Text>
                </span>

                <span className={priceRowStyle}>
                    <Text as="span" variant="headline_3" className={priceStyle}>
                        {property.priceLabel}
                    </Text>
                    {property.pricePerSquareMeterLabel ? (
                        <Text as="span" variant="body_copy_2" className={pricePerAreaStyle}>
                            {property.pricePerSquareMeterLabel}
                        </Text>
                    ) : null}
                </span>

                <span className={featuresStyle}>
                    {property.deliveryLabel ? (
                        <PersonalizedHomepageRecentlyViewedFeature title="Termin oddania" label={property.deliveryLabel}>
                            <CalendarCheckIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                        </PersonalizedHomepageRecentlyViewedFeature>
                    ) : null}
                    <PersonalizedHomepageRecentlyViewedFeature title={property.floorTitle} label={property.floorLabel}>
                        <FloorIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                    <PersonalizedHomepageRecentlyViewedFeature title="Pokoje" label={property.roomsLabel}>
                        <RoomsIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                    <PersonalizedHomepageRecentlyViewedFeature title="Metraż" label={property.areaLabel}>
                        <AreaIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                </span>

                <Button as="div" variant="filled_secondary" size="medium" fullWidth>
                    Zobacz więcej
                </Button>
            </span>
        </a>
    );
};

const PersonalizedHomepageRecentlyViewedFeature = ({title, label, children}: {title: string; label: string; children: ReactNode}) => (
    <span className={featureStyle} title={`${title}: ${label}`}>
        {children}
        <Text as="span" variant="info_txt_1" className={featureLabelStyle}>
            {label}
        </Text>
    </span>
);

const tileStyle = css({
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    overflow: "hidden",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const photoStyle = css({
    position: "relative",
    display: "block",
    flex: "0 0 auto",
    height: "22.6rem",
    borderBottom: "1px solid var(--colors-gray-300)",

    md: {
        height: "18.6rem"
    }
});

const photoImageStyle = css({
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover"
});

const detailsStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    gap: 1.5,
    py: 2,
    px: 1.5
});

const descriptionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const titleStyle = css({
    overflow: "hidden",
    color: "var(--colors-secondary)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const addressStyle = css({
    overflow: "hidden",
    color: "var(--colors-gray-800)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    gap: 1,
    minWidth: 0
});

const priceStyle = css({
    color: "var(--colors-secondary)",
    whiteSpace: "nowrap"
});

const pricePerAreaStyle = css({
    overflow: "hidden",
    color: "var(--colors-gray-700)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const featuresStyle = css({
    display: "flex",
    flex: "1 1 auto",
    alignItems: "center",
    gap: 2,
    minWidth: 0
});

const featureStyle = css({
    display: "inline-flex",
    flex: "0 1 auto",
    alignItems: "center",
    gap: 0.5,
    minWidth: 0
});

const featureLabelStyle = css({
    overflow: "hidden",
    color: "var(--colors-secondary)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {AreaIcon, CalendarCheckIcon, FloorIcon, RoomsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IPersonalizedPropertyCard} from "../../types/IPersonalizedHomepage";

interface IProps {
    property: IPersonalizedPropertyCard;
    index: number;
    onPropertyClick?: (property: IPersonalizedPropertyCard, index: number) => void;
}

export const PersonalizedHomepageRecentlyViewedTile = (props: IProps) => {
    const {property, index, onPropertyClick} = props;

    return (
        <a className={tileStyle} href={property.href} title={property.offerName} onClick={() => onPropertyClick?.(property, index)}>
            <span className={photoStyle}>
                <img className={photoImageStyle} src={property.imageUrl} alt={property.imageAlt} loading="lazy" />
            </span>

            <span className={detailsStyle}>
                <span className={descriptionStyle}>
                    <Text as="span" variant="headline_6" className={titleStyle}>
                        {property.offerName}
                    </Text>
                    <Text as="span" variant="info_txt_1" className={addressStyle}>
                        {property.addressLine}
                    </Text>
                </span>

                <span className={priceRowStyle}>
                    <Text as="span" variant="headline_3" className={priceStyle}>
                        {property.priceLabel}
                    </Text>
                    {property.pricePerSquareMeterLabel ? (
                        <Text as="span" variant="body_copy_2" className={pricePerAreaStyle}>
                            {property.pricePerSquareMeterLabel}
                        </Text>
                    ) : null}
                </span>

                <span className={featuresStyle}>
                    {property.deliveryLabel ? (
                        <PersonalizedHomepageRecentlyViewedFeature title="Termin oddania" label={property.deliveryLabel}>
                            <CalendarCheckIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                        </PersonalizedHomepageRecentlyViewedFeature>
                    ) : null}
                    <PersonalizedHomepageRecentlyViewedFeature title={property.floorTitle} label={property.floorLabel}>
                        <FloorIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                    <PersonalizedHomepageRecentlyViewedFeature title="Pokoje" label={property.roomsLabel}>
                        <RoomsIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                    <PersonalizedHomepageRecentlyViewedFeature title="Metraż" label={property.areaLabel}>
                        <AreaIcon size="1.6" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </PersonalizedHomepageRecentlyViewedFeature>
                </span>

                <Button as="div" variant="filled_secondary" size="medium" fullWidth>
                    Zobacz więcej
                </Button>
            </span>
        </a>
    );
};

const PersonalizedHomepageRecentlyViewedFeature = ({title, label, children}: {title: string; label: string; children: ReactNode}) => (
    <span className={featureStyle} title={`${title}: ${label}`}>
        {children}
        <Text as="span" variant="info_txt_1" className={featureLabelStyle}>
            {label}
        </Text>
    </span>
);

const tileStyle = css({
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    overflow: "hidden",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const photoStyle = css({
    position: "relative",
    display: "block",
    flex: "0 0 auto",
    height: "22.6rem",
    borderBottom: "1px solid var(--colors-gray-300)",

    md: {
        height: "18.6rem"
    }
});

const photoImageStyle = css({
    width: "100%",
    height: "100%",
    maxWidth: "none",
    objectFit: "cover"
});

const detailsStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    gap: 1.5,
    py: 2,
    px: 1.5
});

const descriptionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const titleStyle = css({
    overflow: "hidden",
    color: "var(--colors-secondary)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const addressStyle = css({
    overflow: "hidden",
    color: "var(--colors-gray-800)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    gap: 1,
    minWidth: 0
});

const priceStyle = css({
    color: "var(--colors-secondary)",
    whiteSpace: "nowrap"
});

const pricePerAreaStyle = css({
    overflow: "hidden",
    color: "var(--colors-gray-700)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const featuresStyle = css({
    display: "flex",
    flex: "1 1 auto",
    alignItems: "center",
    gap: 2,
    minWidth: 0
});

const featureStyle = css({
    display: "inline-flex",
    flex: "0 1 auto",
    alignItems: "center",
    gap: 0.5,
    minWidth: 0
});

const featureLabelStyle = css({
    overflow: "hidden",
    color: "var(--colors-secondary)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
